import { Injectable } from "@angular/core";
import { PageableResult } from "../../models/domains/paginator/pageable-result";
import { ClusterType } from "../../models/domains/pbm/Benefit/product-clustertype";
import { AddClusterProduct } from "../../models/domains/pbm/clusters/add-cluster-product.model";
import { ClusterSearchParameters } from "../../models/domains/pbm/clusters/cluster-search-parameters.model";
import { Cluster } from "../../models/domains/pbm/clusters/cluster.model";
import { FileCluster } from "../../models/domains/pbm/clusters/file-cluster";
import { ImportClusterResult } from "../../models/domains/pbm/clusters/import-cluster-result";
import { ExportOrderKey } from "../../models/domains/pbm/exports/export-order-key";
import { ClustersRepository } from "../../repositories/pbm/clusters.repository";

@Injectable({ providedIn: "root" })
export class ClustersService {
  constructor(private clustersRepository: ClustersRepository) {}

  public async getAllClusters(): Promise<ClusterType[]> {
    try {
      return await this.clustersRepository.getAllClusters();
    } catch (error) {
      return await Promise.reject(error);
    }
  }
  public async importCluster(fileCluster: FileCluster): Promise<ImportClusterResult> {
    return await this.clustersRepository.importCluster(fileCluster);
  }

  public async exportCluster(cluster: Cluster): Promise<ExportOrderKey> {
    try {
      return await this.clustersRepository.exportCluster(cluster);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async findClusterExportOrderKey(request: ExportOrderKey): Promise<ExportOrderKey> {
    try {
      const result = await this.clustersRepository.findClusterExportOrderKey(request);
      return Promise.resolve(result);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async getClustersPageableResult(clusterSearchParameters: ClusterSearchParameters): Promise<PageableResult> {
    try {
      return await this.clustersRepository.getClustersPageableResult(clusterSearchParameters);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async getCluster(clusterKey: string): Promise<Cluster> {
    try {
      return await this.clustersRepository.getCluster(clusterKey);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async addClusterProduct(addClusterProduct: AddClusterProduct): Promise<any> {
    try {
      return await this.clustersRepository.addClusterProduct(addClusterProduct);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async addNewCluster(cluster: Cluster): Promise<any> {
    try {
      return await this.clustersRepository.addNewCluster(cluster);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async deleteClusterProduct(clusterKey: string, ean: string): Promise<any> {
    try {
      return await this.clustersRepository.deleteClusterProduct(clusterKey, ean);
    } catch (error) {
      return await Promise.reject(error);
    }
  }

  public async getClusterProducts(clusterKey: string, clusterSearchParameters: ClusterSearchParameters): Promise<any> {
    try {
      return await this.clustersRepository.getClusterProducts(clusterKey, clusterSearchParameters);
    } catch (error) {
      return await Promise.reject(error);
    }
  }
}
